import React from "react";
import { Link } from "react-router-dom";

const DrugItem = ({ drug, badgeLabel, badgeValue }) => {
  return (
    <div className="top--selling">
      <Link className="grid--card" to={`/medicine/${drug?.id}/details`}>
        <div className="cont pt-2">
          <h6 className="line--limit-2">{drug?.name}</h6>
        </div>
        <div className="ml-auto">
          <span className="badge badge-soft">
            {badgeLabel}: {badgeValue}
          </span>
        </div>
      </Link>
    </div>
  );
};

export default DrugItem;